<template>
  <jet-authentication-card>
    <template #logo>
      <jet-authentication-card-logo/>
    </template>
    <login-form :disable-reload="true"></login-form>
  </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import LoginForm from "@/Pages/Auth/LoginForm";

export default {
  components: {
    LoginForm,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetValidationErrors
  },
  data() {
  },
}
</script>
